import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestInvoiceItemMasterList(params) {
  if (params === undefined) {
    return fetch.post(
      `${BASE_URL}/api/app/invoice-item-master/get-invoice-master`,
      {
        limit: Number.MAX_SAFE_INTEGER,
      }
    );
  } else {
    let limit = Number.MAX_SAFE_INTEGER;
    // params["limit"] = limit;
    return fetch.post(
      `${BASE_URL}/api/app/invoice-item-master/get-invoice-master`,
      params
    );
  }
}

export function requestInvoiceItemMasterCreate(data) {
  return fetch.post(`${BASE_URL}/api/app/invoice-item-master`, data);
}

export function requestInvoiceItemMasterUpdate(data) {
  const body = { ...data };
  delete body["_id"];
  return fetch.put(`${BASE_URL}/api/app/invoice-item-master/${data._id}`, body);
}
